import {makeAutoObservable} from "mobx";
import localeDataKo from '../locale/localeDataKo.json';
import localeDataEn from '../locale/localeDataEn.json';
import localeDataZh from '../locale/localeDataZh.json';
import localeDataJa from '../locale/localeDataJa.json';
import localeDataTh from '../locale/localeDataTh.json';
import localeDataVn from '../locale/localeDataVn.json';
import localeDataMn from '../locale/localeDataMn.json';
import localeDataId from '../locale/localeDataId.json';
import localeDataRu from '../locale/localeDataRu.json';
import localeDataTw from '../locale/localeDataTw.json';

const localeData = {
    'ko': localeDataKo,
    'en': localeDataEn,
    'zh': localeDataZh,
    'ja': localeDataJa,
    'th': localeDataTh,
    'vi': localeDataVn,
    'mn': localeDataMn,
    'id': localeDataId,
    'ru': localeDataRu,
    'tw': localeDataTw,
};

export const LanguageKey = '_PMING_LANG';
const DefaultLocale = 'en';

export default class LocaleStore {
    constructor() {
        this.locale = this.getBrowserLocale();
        this.localeMessage = localeData[this.locale];

        makeAutoObservable(this);
        this.changeLocale(this.locale);
    }

    getBrowserLocale() {
        const language = localStorage.getItem(LanguageKey) || (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage || navigator.browserLanguage;
        if (language.includes('TW') || language.includes('Hant')) {
            return 'tw';
        } else {
            return language.toLowerCase().split(/[_-]+/)[0];
        }
    };

    changeLocale(locale) {
        if(localeData[locale]) {
            this.locale = locale;
            this.localeMessage = localeData[locale];
            localStorage.setItem(LanguageKey, locale);
        } else {
            console.warn(`Locale ${locale} does not supported : set to default ${DefaultLocale}`);

            this.locale = DefaultLocale;
            this.localeMessage = localeData[DefaultLocale];
            localStorage.setItem(LanguageKey, DefaultLocale);
        }
    }
}
